import { Constants, Notifications, Permissions } from 'expo';
import { post, remove, URL, db, storage, cache } from 'utils';
import { isWeb, isIOS, isAndroid, isNative } from 'core';
import { fetch } from './fetch';
import { loadInitialData } from 'actions';
import { SESSIONS, NOTIFICATION_CHANNEL } from 'constants';
import { lang } from 'lang';

export const VERIFY_ACCOUNT = 'AUTH.VERIFY_ACCOUNT';
export const PROVIDE_ACCOUNT = 'AUTH.PROVIDE_ACCOUNT';
export const LOGOUT = 'AUTH.LOGOUT';
export const REMOVE_SESSION = 'AUTH.REMOVE_SESSION';
export const ADD_SESSIONS = 'AUTH.ADD_SESSIONS';
export const UPDATE_SESSIONS = 'AUTH.UPDATE_SESSIONS';
export const REMOVE_SESSIONS = 'AUTH.REMOVE_SESSIONS';
export const SET_SESSIONS = 'AUTH.SET_SESSIONS';

export const LOAD_SESSIONS = 'AUTH.LOAD_SESSIONS';

export const provideAccount = params => (dispatch, getState) => {
    params.lang = lang.LANG_CODE;
    const request = { url: URL.AUTH.PROVIDE_ACCOUNT, method: post, params };
    fetch(request, PROVIDE_ACCOUNT);
};

export const verifyAccount = params => async (dispatch, getState) => {
    const { platform, getWebViewUserAgentAsync } = !isWeb ? Constants : {};
    params.lang = lang.LANG_CODE;
    params.app = platform ? `fosol ${Object.keys(platform)[0]}` : `fosol web`;
    params.ios = isIOS ? `${platform.ios.model} - ios ${platform.ios.systemVersion}` : null;
    params.android = isAndroid && (await getWebViewUserAgentAsync());
    params.push = isNative ? await getPushToken() : null;

    const request = { url: URL.AUTH.VERIFY_ACCOUNT, method: post, params };
    fetch(request, VERIFY_ACCOUNT, auth => loadInitialData(auth));
};

export const logout = () => async (dispatch, getState) => {
    const user = getState().user;
    const auth = { id: user.id, session_id: user.current_session };
    db.signOut(auth);
    storage.clear();
    cache.clear();
    dispatch(removeSession(SESSIONS.CURRENT));
    dispatch({ type: LOGOUT });
};

export const removeSession = params => (dispatch, getState) => {
    const request = { url: URL.AUTH.REMOVE_SESSION + params, method: remove };
    fetch(request, REMOVE_SESSION);
};

export const setSessions = (auth, type = LOAD_SESSIONS, remote) => (dispatch, getState) => data => {
    if ((type === REMOVE_SESSIONS && data.id === auth.session_id) || (type === LOAD_SESSIONS && (!data || !data[auth.session_id] || !data[auth.session_id].id))) {
        dispatch(logout());
    } else if (type === LOAD_SESSIONS) {
        dispatch({ type, payload: { id: 'list', data } });
    } else {
        data.id && dispatch({ type, payload: { id: 'list', data } });
    }
};
export const getSessions = auth => (dispatch, getState) => {
    const once = dispatch(setSessions(auth, LOAD_SESSIONS, true));
    const changed = dispatch(setSessions(auth, UPDATE_SESSIONS));
    const added = dispatch(setSessions(auth, ADD_SESSIONS));
    const removed = dispatch(setSessions(auth, REMOVE_SESSIONS));
    db.loadAndWatch(`user_session/${auth.id}`, { once, added, changed, removed });
};

const getPushToken = async () => {
    const { status: existingStatus } = await Permissions.getAsync(Permissions.NOTIFICATIONS);
    let finalStatus = existingStatus;

    // only ask if permissions have not already been determined, because
    // iOS won't necessarily prompt the user a second time.
    if (existingStatus !== 'granted') {
        // Android remote notification permissions are granted during the app
        // install, so this will only ask on iOS
        const { status } = await Permissions.askAsync(Permissions.NOTIFICATIONS);
        finalStatus = status;
    }

    // Stop here if the user did not grant permissions
    if (finalStatus !== 'granted') {
        return null;
    }

    // Get the token that uniquely identifies this device
    let token = await Notifications.getExpoPushTokenAsync();

    if (isAndroid) {
        Notifications.createChannelAndroidAsync(NOTIFICATION_CHANNEL.CHAT_MESSAGES, {
            name: 'Chat Messages',
            sound: true,
            badge: true,
            vibrate: [0, 200]
        });
    }

    return token;
};



// WEBPACK FOOTER //
// ./src/actions/auth.js